// extracted by mini-css-extract-plugin
module.exports = {"input":"_2o5ByW"};